import { createLogger } from "utils/logging";
import { captureErrorWithPayload } from "utils/error";
import { BenefitElement, defineElement, buildSearchParams, callBackend } from "../benefit_base";

const ATTRIBUTE_NAMES = {
	FEATURE: "feature",
	TEAM: "team",
	SKU: "sku",
	PARTNER_ID: "partner-id",
};

const log = createLogger("tag", "cashback");
const CASHBACK_ELEMENT_NAME = "ft9-cashback-v1";

const REQUEST_INITIATOR_FILE_NAME = new URL(import.meta.url).pathname.split("/").at(-1) ?? "unknown";

const ERROR_KEY = "ft9-cashback-not-ok";
const ERROR_LABELS = { service: "tag", module: "cashback", team: "ft9" };

export class CashbackElement extends BenefitElement {
	private validateHydrationPreconditions(): boolean {
		const sku = this.getAttribute(ATTRIBUTE_NAMES.SKU);
		if (!sku) {
			log.error("No sku provided, cannot load cashback.");
			captureErrorWithPayload({ message: "No sku provided", type: ERROR_KEY, labels: ERROR_LABELS });
			return false;
		}
		const partnerId = this.getAttribute(ATTRIBUTE_NAMES.PARTNER_ID);
		/*                                                                             */
		/*                                                                                     */
		/*                        */
		return partnerId === "1000000" || partnerId === "999999999";
	}

	protected async hydrate(): Promise<void> {
		this.replaceChildren(); /*                       */

		if (!this.validateHydrationPreconditions()) return;

		const params = {
			sku: this.getAttribute(ATTRIBUTE_NAMES.SKU),
			partnerId: this.getAttribute(ATTRIBUTE_NAMES.PARTNER_ID),
		};
		const searchParams = buildSearchParams(params);
		log.info("Calling tag for %s with %s", this.id || "id-not-set", searchParams.toString());

		try {
			const url = new URL(`/benefit-tag/cashback?${searchParams}`, globalThis.location.origin);
			const options = {
				url,
				feature: this.getAttribute(ATTRIBUTE_NAMES.FEATURE),
				team: this.getAttribute(ATTRIBUTE_NAMES.TEAM),
				initiator: REQUEST_INITIATOR_FILE_NAME,
				priority: "high" as const,
				logging: {
					logger: log,
					errorKey: ERROR_KEY,
					errorLabels: ERROR_LABELS,
				},
			};

			const response = await callBackend(options);
			this.innerHTML = await response.text();
			this.initCashback();
		} catch {
			/*                                                                    */
			/*                                                                          */
		}
	}

	private initCashback() {
		const cashback = this.firstElementChild;
		if (!cashback || !(cashback instanceof HTMLElement)) {
			return;
		}

		if (cashback.dataset.expirationDate) {
			this.triggerReloadAt(cashback.dataset.expirationDate);
		}
	}
}

defineElement(CashbackElement, CASHBACK_ELEMENT_NAME, "ftnine_emergency_custom_element_disable_cashback");
